const API_KEY = "3660e17715fda86808008c49afac3d60";
const requests = {
    fetchTrending: `/trending/all/week?api_key=${API_KEY}&language=en-US`,
	fetchNetflixOriginals: `/discover/tv?api_key=${API_KEY}&with_networks=213&with_original_language=en`,
	fetchTopRated: `/movie/top_rated?api_key=${API_KEY}&language=en-US`,
    fetchHistoryMovies: `/discover/movie?api_key=${API_KEY}&with_genres=36`,
	fetchAnimationMovies: `/discover/movie?api_key=${API_KEY}&with_genres=16`,
	fetchFantasyMovies: `/discover/movie?api_key=${API_KEY}&with_genres=14`,
	fetchRomanceMovies: `/discover/movie?api_key=${API_KEY}&with_genres=10749`,
	fetchSiFiMovies: `/discover/movie?api_key=${API_KEY}&with_genres=878`,
}

export default requests;